import api from "./index";

export const checkMandatoryDocumentsService = async (opportunityId) =>
  await api.get(`/upload-flow/opportunity/${opportunityId}/documents`);

export const registerDocumentDownloadAttemptService = async (params) =>
  await api.post(`/upload-flow/register-document-download`, {...params});